/* eslint-disable import/order */
import type { EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmComplianceRoute } from '@jira/router-routes__products-jsm-compliance-routes/src/productsJsmComplianceRoute.tsx';
import ProductsJsmCompliance, { LazyProductsJsmCompliance } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const productsJsmCompliancePageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-products-jsm-compliance", jiraSpaEntry: "async-products-jsm-compliance" */ '@jira/spa-apps__admin-pages-products-jsm-compliance/src/ProductsJsmComplianceType.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const productsJsmComplianceRouteEntry: Route = createEntry(
	productsJsmComplianceRoute,
	() => ({
		group: 'global-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_1') ? undefined : ProductsJsmCompliance,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_1') ? productsJsmCompliancePageEntryPoint : undefined,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		forPaint: [LazyAtlassianNavigation, LazyProductsJsmCompliance],
		ufoName: 'admin.jsm-compliance',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
